<template>
    <div class="halogen-kohlenwasserstoffe">
        <p>
            <b>Beilsteinprobe</b>
            <br />
            Kupferdraht + Probe in Brennerflamme ergibt eine grüne
            Flammenfärbung (dies sind flüchtende Kupferhalogenide)
        </p>
    </div>
</template>

<script>
export default {
    name: 'halogen-kohlenwasserstoffe',
};
</script>
